import type { GrupoDocumentos, ListaDocumentosResponse, ListaItensResponse } from '../types';

type GrupoItens = NonNullable<ListaItensResponse['documents']['nf3e']>;

function grupoDocumentosTemDados(grupo?: GrupoDocumentos): boolean {
  return !!grupo && (grupo.totalItens > 0 || grupo.itens.length > 0);
}

function grupoItensTemDados(grupo?: GrupoItens): boolean {
  return !!grupo && (grupo.totalItens > 0 || grupo.items.length > 0);
}

export function normalizeListaDocumentosResponse(
  response: ListaDocumentosResponse
): ListaDocumentosResponse {
  const documentos = response.data?.documentos;

  if (!documentos) {
    return response;
  }

  const grupoNf3e = documentos.nf3e;
  const grupoNf3 = documentos.nf3;

  if (grupoDocumentosTemDados(grupoNf3e) || !grupoDocumentosTemDados(grupoNf3)) {
    return response;
  }

  return {
    ...response,
    data: {
      ...response.data,
      documentos: {
        ...documentos,
        nf3e: grupoNf3,
      },
    },
  };
}

export function normalizeListaDocumentosItensResponse(
  response: ListaItensResponse
): ListaItensResponse {
  const documentos = response.documents;

  if (!documentos) {
    return response;
  }

  const grupoNf3e = documentos.nf3e;
  const grupoNf3 = documentos.nf3;

  if (grupoItensTemDados(grupoNf3e) || !grupoItensTemDados(grupoNf3)) {
    return response;
  }

  return {
    ...response,
    documents: {
      ...documentos,
      nf3e: grupoNf3,
    },
  };
}
